// Atlas identity: everything the app needs to know about WHICH wine
// country it is serving. The German values here are the defaults; a
// sibling atlas (src/atlas/<id>/atlasConfig.js) shadows this module via
// the VITE_ATLAS alias in vite.config — see src/atlas/README.md.
// Germany's build resolves this exact file, so the live app is
// byte-identical to the pre-atlas era.
export const ATLAS = {
  id: 'germany',
  name: 'German Wine Map',
  country: 'Germany',
  // brand flag-grape + the hidden click-to-toggle alternate title
  logoUrl: '/flag-grape.png',
  altTitle: 'Weinlandkarte',
  // wine-law terminology layer: what the UI calls the region tiers
  terms: { region: 'Anbaugebiet', subregion: 'Bereich' },
  // regions legally nested inside another region (none in Germany)
  nestedRegions: {},
  // clickable water bodies opening a geo panel (none in Germany —
  // rivers live in the Key Rivers & Mtns layer there)
  clickableLakes: [],
  // overview label typography: names that stack onto two lines, and
  // per-region size tweaks (the geo view pins one uniform size)
  regionLabelLines: { 'Hessische Bergstraße': ['Hessische', 'Bergstraße'] },
  regionLabelScale: { 'Hessische Bergstraße': 0.75 },
  // country boundary geometry for the outside-mask (public/ asset)
  boundaryUrl: '/germany.json',
  // overview fit + pan limits (see FitToGermany for the reasoning)
  fitBounds: [[47.4, 6.0], [51.8, 13.5]],
  maxBounds: { desktop: [[42, -6], [60, 33]], mobile: [[34, -8], [62, 26]] },
  satelliteUrl: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  satelliteMaxNativeZoom: 19, // Esri serves native tiles to z19
  hillshadeUrl: 'https://server.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}',
  // layers an atlas can switch off wholesale (missing data / licensing)
  features: {
    regionOutline: false, // region view shows no boundary line in Germany
    satellite: true,
    terrain: true,
    temp: true,
    sun: true,
    geo: true,        // Key Rivers & Mountains view
    producers: true,  // Key Producers view
    producersOnByDefault: false, // region view: producer markers start hidden
    study: true,      // Study Mode button + /study deep link
    twins: true,      // Vineyard Twins section in the vineyard panel
  },
};
